import { Navigate } from 'react-router-dom';
import { type SystemRole, hasMinimumRole } from '@peles/shared';
import { useAuth } from '../../context/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  minimumRole?: SystemRole;
}

export function ProtectedRoute({ children, minimumRole }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, user } = useAuth();

  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
        }}
      >
        <p>Loading...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (minimumRole && user && !hasMinimumRole(user.systemRole, minimumRole)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <>{children}</>;
}
